// Una fattura appena caricata non è ancora autorizzata dal proxy: compare
// nello storico della sessione solo finché la sua anteprima locale è presente.
export const visibleFatturaHistory = (items, localPreviews) =>
  items.filter(item => !item.pending || !!localPreviews[item.path]);